import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import loadExperiments from 'redux/actions/experiments/loadExperiments';
var createCellLevelMetadata = function createCellLevelMetadata(experimentId, body) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var signedUploadUrlParams;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellLevelMeta"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            });
          case 3:
            signedUploadUrlParams = _context.sent;
            _context.next = 6;
            return dispatch(loadExperiments());
          case 6:
            return _context.abrupt("return", signedUploadUrlParams.data);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            handleError(_context.t0, _context.t0.userMessage);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default createCellLevelMetadata;